
import Common     from '@/plugins/common'
import validators from './validators.js'
import postToAddr from './postToAddr.js'

import CnmnForm     from './cnmn-form'
import CnmnField    from './cnmn-field'
import CnmnValidate from './cnmn-validate'
import CnmnModal    from './cnmn-modal'
import CnmnConfirm  from './cnmn-confirm'

import Vue2SlotCalendarEx from './vue2-slot-calendar-ex'
import CnmnFileInput      from './cnmn-file-input'
import CnmnFileDrop       from './cnmn-file-drop'
import CnmnBtn            from './cnmn-btn'

import CnmnIconLoading    from './cnmn-icon-loading'

export default {
  install(Vue, options) {
    Vue.use(Common)
    Vue.use(validators)
    Vue.use(postToAddr)

    Vue.component('cnmn-form',     CnmnForm)
    Vue.component('cnmn-field',    CnmnField)
    Vue.component('cnmn-validate', CnmnValidate)
    Vue.component('cnmn-modal',    CnmnModal)
    Vue.component('cnmn-confirm',  CnmnConfirm)

    Vue.component('vue2-slot-calendar-ex',  Vue2SlotCalendarEx)
    Vue.component('cnmn-file-input',        CnmnFileInput)
    Vue.component('cnmn-file-drop',         CnmnFileDrop)
    Vue.component('cnmn-btn',               CnmnBtn)

    Vue.component('cnmn-icon-loading',      CnmnIconLoading)
  },
}
